// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_sd-0";
export var checkoutRateBadgeLink = "_sd-1";